export default __webpack_public_path__ + "static/media/prize.d8a1c768.jpg";